var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-select',{attrs:{"value":_vm.value,"options":_vm.options},on:{"input":_vm.input}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }